import { ReactSVG } from 'react-svg';
import cslx from 'clsx';
import checkMark from '../../assets/icons/functions/checkmark-green.svg';
import { InvoiceStatuses } from '../InvoiceStatus/InvoiceStatus';

interface PaidStatusPillProps {
  status: keyof typeof InvoiceStatuses;
  t: any;
}

type StatusProps = {
  [key in InvoiceStatuses]: {
    styles: string;
    showCheckmark?: boolean;
  };
};

const defaultStyles =
  'capitalize rounded-8-0 px-1-4 py-0-4 text-2-0 md:text-1-4 font-md inline-block';

const propsByStatus: StatusProps = {
  [InvoiceStatuses.PAID]: {
    styles: 'bg-secondary-green text-primary-green',
    showCheckmark: true,
  },
  [InvoiceStatuses.SHIPPING]: {
    styles: 'bg-secondary-green text-primary-green',
    showCheckmark: true,
  },
  [InvoiceStatuses.COMPLETED]: {
    styles: 'bg-secondary-green text-primary-green',
    showCheckmark: true,
  },
  [InvoiceStatuses.CREATED]: {
    styles: 'bg-primary-yellow text-primary-dark',
  },
  [InvoiceStatuses.PENDING]: {
    styles: 'bg-primary-yellow text-primary-dark',
  },
  [InvoiceStatuses.AUTHORIZED]: {
    styles: 'bg-primary-yellow text-primary-dark',
  },
  [InvoiceStatuses.UNPAID]: {
    styles: 'bg-secondary-grey text-primary-dark',
  },
  [InvoiceStatuses.CANCELLED]: {
    styles: 'bg-secondary-grey text-primary-dark',
  },
  [InvoiceStatuses.EXPIRED]: {
    styles: 'bg-secondary-grey text-primary-dark',
  },
};

const PaidStatusPill: React.FC<PaidStatusPillProps> = (props) => {
  return (
    <div className={cslx(propsByStatus[props.status].styles, defaultStyles)}>
      <div className="flex items-center">
        {propsByStatus[props.status].showCheckmark && (
          <ReactSVG src={checkMark} className="mr-1-0 text-secondary-green" />
        )}
        <span>
          {props.t(`customer.invoices.${props.status.toLowerCase()}`)}
        </span>
      </div>
    </div>
  );
};

export default PaidStatusPill;
